/**
 * Created by anthony on 6/21/14.
 */
var modelService = angular.module('modelService', ['familyThresholds', 'editSums', 'familyThreshEditSums', 'vehicleModel', 'taxSettingAffectedFamiliesModel',
    'noteModel', 'historyDataModel', 'dependantModel', 'childrenModel', 'schoolAddendumModel', 'helpSystemModel', 'gradeSetupModel', 'permissionModel',
    'askSchoolSpecificQuestionsModel', 'appealsModel', 'schoolModel', 'policyModel', 'realEstateModel', 'editSumsModel', 'committeeModeModel', 'committeeUserModel',
    'applicantModel', 'budgetsModel', 'schoolSubcategoriesModel', 'schoolThresholdsModel', 'feeAgreementModel', 'schoolTaxModel', 'documentsModel', 'historyDataModel',
    'reminderModel', 'preFastHistoryModel', 'applicationsModel', 'flagModel', 'vouchersModel', 'addedAllowanceModel', 'changeLogModel', 'reportsModel',
    'schoolContactsModel', 'taxEmailModel', 'familyTaxModel', 'voucherOrderModel', 'vouStatementModel', 'spreadsheetModel', 'awardLetterTemplatesModel',
    'awardLetterModel', 'zillowDataModel', 'CSnotesModel', 'taxLogModel', 'parentCommentsModel', 'notificationModel']);

modelService.service('ModelService', function(ApplicationService, RestService, FamilyThresholdsService, EditSumsService,
    FamilyThreshEditSumsService, NoteModelService, ReminderModelService,
    SchoolAddendumModelFactory, SchoolAddendumModelService, HelpSystemModelService, GradeSetupModelService,
    AskSchoolSpecificQuestionsModelService, AppealsModelService, SchoolModelService, PolicyModelService,
    ApplicantModelService, FamilyModelService, AppModelService, BudgetsModelService, SchoolSubcategoriesModelService,
    SchoolThresholdsModelService, FeeAgreementModelService, SchoolTaxModelService, DocumentsModelService, ApplicationsModelService,
    FlagModelService, VouchersModelService, SchoolContactsModelService, FamilyTaxModelService, VoucherOrderModelService,
    VouStatementModelService, SpreadsheetModelService, AwardLetterTemplatesModelService, AwardLetterModelService,
    ChildrenModelService, DependantModelService, CSNotesModelService, TaxLogModelService, ParentCommentsModelService, NotificationModelService){

    return {
        FamilyThresholdsService: FamilyThresholdsService,
        EditSumsService : EditSumsService,
        FamilyThreshEditSumsService: FamilyThreshEditSumsService,
        app:
        {
            note : NoteModelService, 
            reminder: ReminderModelService,
            applicant: ApplicantModelService,
            AwardApplicant: AppModelService.AwardApplicant,
            getEndpoint: AppModelService.getEndpoint,
            budgets: BudgetsModelService,
            awardLetter: AwardLetterModelService
        },
        family:
        {
            get: FamilyModelService.get,
            put: FamilyModelService.put,
            post: FamilyModelService.post,
            data: FamilyModelService.data,
            getEndpoint: FamilyModelService.getEndpoint,
            familyTax: FamilyTaxModelService,
            children: ChildrenModelService,
            dependant: DependantModelService,
            taxLog: TaxLogModelService
        },
        school:
        {
            subcategory: SchoolSubcategoriesModelService,
            addendum: SchoolAddendumModelService,
            tuition: GradeSetupModelService,
            extraQuestions: AskSchoolSpecificQuestionsModelService,
            appealQuestions: AppealsModelService,
            put: SchoolModelService.put,
            get: SchoolModelService.get,
            policy: PolicyModelService,
            primaryKey: SchoolModelService.primaryKey,
            set: SchoolModelService.set,
            getEndpoint: SchoolModelService.getEndpoint,
            schoolThresholds: SchoolThresholdsModelService,
            feeAgreement: FeeAgreementModelService,
            schoolTax: SchoolTaxModelService,
            documents: DocumentsModelService,
            applications: ApplicationsModelService,
            flags: FlagModelService,
            vouchers: VouchersModelService,
            contacts: SchoolContactsModelService,
            voucherOrder: VoucherOrderModelService,
            vouStatement: VouStatementModelService,
            spreadsheet: SpreadsheetModelService,
            awardLetterTemplates: AwardLetterTemplatesModelService,
            CSnotes: CSNotesModelService,
            parentComments: ParentCommentsModelService,
            notifications: NotificationModelService
        },
        helpSystem: HelpSystemModelService
    }
});



